/*    
 *  _________________________________________
 * / Stop right there, ya dingus. This file  \
 * \ should not be edited.                   /
 *  -----------------------------------------
 *  \
 *   \
 *      __
 *     /  \
 *     |  |
 *     @  @
 *     |  |
 *     || |/
 *     || ||
 *     |\_/|
 *     \___/
 *    
 * This file is automatically generated through https://localise.biz.
 *                                                                         
 * To update this file:
 *
 *  $ npm run update-language
 *
 * Last update:    Wed Jan 22 2025 15:40:47 GMT+0100 (Central European Standard Time)
 * Language keys:  2
 * Language code:  en
 *
 */

const language = {
  "button": {
    "continue": "Continue"
  },
  "component": {
    "questionNumber": {
      "questionNumberCurrent": "Question %{numberCurrent}",
      "questionNumberMax": "of %{numberMax}",
      "optional": " (Optional)"
    },
    "textInputBox": "I want to add...",
    "answerType": {
      "button": {
        "finishTheSurvey": "Finish the survey",
        "continue": "Continue"
      }
    },
    "finishSurveyDisplay": {
      "thanks": "Thanks for the feedback!",
      "explanation": "This helps us a lot to keep improving your safety."
    },
    "alert": {
      "error": "An error occurred while updating your responses. Please try again."
    },
    "loading": {
      "loading": "Loading...",
      "cannotOpen": "We cannot open the survey.",
      "openSurveyAgain": "Please close the tab and open the survey again. If the issue persists, please contact support."
    }
  }
} as const

export default language